import { render, staticRenderFns } from "./shuttlePay.vue?vue&type=template&id=4a476fe7&scoped=true&"
import script from "./shuttlePay.vue?vue&type=script&lang=js&"
export * from "./shuttlePay.vue?vue&type=script&lang=js&"
import style0 from "./shuttlePay.vue?vue&type=style&index=0&id=4a476fe7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a476fe7",
  null
  
)

export default component.exports